import { render, staticRenderFns } from "./Carregando.vue?vue&type=template&id=40a0ce74&"
import script from "./Carregando.vue?vue&type=script&lang=js&"
export * from "./Carregando.vue?vue&type=script&lang=js&"
import style0 from "./Carregando.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QCircularProgress from 'quasar/src/components/circular-progress/QCircularProgress.js';
import qInstall from "../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QCircularProgress});
